export enum PaymentActionTypes {
  UpdatePayment = 'UpdatePayment',
}
